import React from 'react';
import './Form.css';

export default class Form extends React.Component {
  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
    this.state = {
      status: '',
    };
  }

  render() {
    const { status } = this.state;
    return (
      <div className='formBox'>
        <section className='contact-form'>
          <form
            className='formBody'
            onSubmit={this.submitForm}
            action='https://formspree.io/f/mvovlezg'
            method='POST'
          >
            <label>
              <h2>Email:</h2>
              <input type='email' name='email' />
            </label>
            <label>
              <h2>Message:</h2>
              <input type='text' textarea='' name='message' />
            </label>
            {status === 'SUCCESS' ? <p>Thanks!</p> : <button>Submit</button>}
            {status === 'ERROR' && <p>Ooops! There was an error.</p>}
          </form>
        </section>
      </div>
    );
  }

  submitForm(ev) {
    ev.preventDefault();
    const form = ev.target;
    const data = new FormData(form);
    const xhr = new XMLHttpRequest();
    xhr.open(form.method, form.action);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.onreadystatechange = () => {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;
      if (xhr.status === 200) {
        form.reset();
        this.setState({ status: 'SUCCESS' });
      } else {
        this.setState({ status: 'ERROR' });
      }
    };
    xhr.send(data);
  }
}
